// Gallery landing page — iOS Settings-style grouped list.

import { Chevron } from "./MockShell";
import { ToastHost } from "./toast";

const mocks = [
  { slug: "register", title: "Register", summary: "Scan, build a ticket, pay" },
  { slug: "today", title: "Today board", summary: "Live board of what needs attention" },
  { slug: "firearm-sale", title: "Firearm sale", summary: "Customer to handover" },
  { slug: "used-gun-intake", title: "Used-gun intake", summary: "AI-assisted ID and valuation" },
  { slug: "handoff", title: "Handoff", summary: "Tickets, send to counter, lease" },
];

export function MockGallery() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="bg-slate-900 text-slate-300 text-[11px] py-1 px-3 flex items-center justify-center gap-2 tracking-wide">
        <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
        Preview — mockup data
      </div>

      <main className="flex-1 max-w-2xl mx-auto w-full px-4 sm:px-6 pt-10 pb-16">
        <h1 className="text-[40px] leading-[1.05] font-bold tracking-tight">BetterPOS</h1>
        <p className="text-slate-500 mt-1.5 text-[17px]">Clickable mockups.</p>

        <div className="mt-10">
          <h2 className="text-[13px] font-normal text-slate-500 uppercase tracking-wider px-4 pb-1.5">
            Flows
          </h2>
          <div className="bg-white rounded-2xl overflow-hidden">
            {mocks.map((m) => (
              <a
                key={m.slug}
                href={`#/mocks/${m.slug}`}
                className="flex items-center gap-3 px-4 py-3.5 min-h-14 hairline last:shadow-none active:bg-slate-50"
              >
                <span className="flex-1 min-w-0">
                  <span className="block text-[17px] text-slate-900 truncate">{m.title}</span>
                  <span className="block text-[13px] text-slate-500 truncate">{m.summary}</span>
                </span>
                <Chevron className="text-slate-300" />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10">
          <h2 className="text-[13px] font-normal text-slate-500 uppercase tracking-wider px-4 pb-1.5">
            Diagnostics
          </h2>
          <div className="bg-white rounded-2xl overflow-hidden">
            <a
              href="#/health"
              className="flex items-center gap-3 px-4 py-3.5 min-h-14 active:bg-slate-50"
            >
              <span className="flex-1 text-[17px] text-slate-900">API health</span>
              <Chevron className="text-slate-300" />
            </a>
          </div>
        </div>
      </main>
      <ToastHost />
    </div>
  );
}
